import type { ApiUserSavedSearchResponse, GetLastSavedSearchResponse } from "./types"
import type { NextRequest } from "@/modules/fetch/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { computeUserSavedSearch } from "@/modules/jobAds/client/utils/computeUserSavedSearch"
import { logger } from "@/modules/monitoring/logger"

import { GET_USER_MONO_SAVED_SEARCH_ENDPOINT } from "./constants"

type GetUserSavedSearchParams = {
  nextRequest?: NextRequest
}

export const getUserSavedSearch = async ({
  nextRequest,
}: GetUserSavedSearchParams = {}): Promise<GetLastSavedSearchResponse> =>
  fetcher(GET_USER_MONO_SAVED_SEARCH_ENDPOINT, {
    nextRequest,
    serviceDomain: "KRAKEND_API",
  })
    .then(
      getResultFromResponse<ApiUserSavedSearchResponse, GetLastSavedSearchResponse>({
        transformResult: result => {
          const formattedResult = toCamelCaseKeys(result)

          const startDatesSubstrings = ["2025_00", "2026_00"]
          const hasWrongStartDates = startDatesSubstrings.some(startDate =>
            formattedResult.savedSearch?.attributes.includes(startDate)
          )
          if (hasWrongStartDates) {
            logger.error(
              `An issue occurred while fetching ${GET_USER_MONO_SAVED_SEARCH_ENDPOINT} endpoint from "job_ads_fo_index" module, GET method. Invalid StartDate : ${JSON.stringify(
                result
              )}`
            )
          }

          return formattedResult.savedSearch && formattedResult.savedSearch.id
            ? computeUserSavedSearch(formattedResult.savedSearch)
            : null
        },
      })
    )
    .catch(error => {
      if (error.status === 404) {
        return null
      }

      throw error
    })
    .catch(handleFetchError(GET_USER_MONO_SAVED_SEARCH_ENDPOINT))
    .catch(() => null)
